import { CHECK_STATES } from '../constants/systemVerificationContent'

function StateBadge({ state }) {
  if (state === CHECK_STATES.PASS) {
    return (
      <div className="flex items-center gap-2 text-primary">
        <span className="text-xs font-bold uppercase tracking-wider">Pass</span>
        <span className="material-symbols-outlined text-xl" style={{ fontVariationSettings: "'FILL' 1" }}>
          check_circle
        </span>
      </div>
    )
  }

  if (state === CHECK_STATES.CHECKING) {
    return (
      <div className="flex items-center gap-2 text-on-surface-variant">
        <span className="text-xs font-bold uppercase tracking-wider">Checking</span>
        <span className="h-4 w-4 animate-spin rounded-full border-2 border-primary/20 border-t-primary" />
      </div>
    )
  }

  if (state === CHECK_STATES.FAIL) {
    return (
      <div className="flex items-center gap-2 text-error">
        <span className="text-xs font-bold uppercase tracking-wider">Fail</span>
        <span className="material-symbols-outlined text-xl">cancel</span>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-2 text-on-surface-variant">
      <span className="text-xs font-bold uppercase tracking-wider">Pending</span>
      <span className="material-symbols-outlined text-xl">hourglass_empty</span>
    </div>
  )
}

export default function VerificationStatusRow({ label, icon, state }) {
  const isPass = state === CHECK_STATES.PASS
  const isPending = state === CHECK_STATES.PENDING

  return (
    <div
      className={`flex items-center justify-between rounded-md p-4 transition-all duration-300 ${
        isPending ? 'bg-surface-container-low/50' : 'bg-surface-container-low'
      } ${isPending ? 'opacity-60' : ''}`}
    >
      <div className="flex items-center gap-4">
        <div className={`flex h-8 w-8 items-center justify-center rounded-full ${isPass ? 'bg-primary/10' : 'bg-on-surface-variant/10'}`}>
          <span
            className={`material-symbols-outlined text-xl ${isPass ? 'text-primary' : 'text-on-surface-variant'}`}
            style={isPass ? { fontVariationSettings: "'FILL' 1" } : undefined}
          >
            {icon}
          </span>
        </div>
        <span className="font-label font-semibold text-on-surface">{label}</span>
      </div>
      <StateBadge state={state} />
    </div>
  )
}
